// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.few-shot-right-con , .few-shot-left-con {
   width: 100%;
} 
 
 
 
 .few-shot-left-con tr[aria-rowindex="2"] {
  display: none;
}

.few-shot-right-con .header{
   height: 38.5px;
   padding: 0;
   margin: 0;
   display: flex;
   align-items: center;
   gap: 300px;
   background-color:var(--grid-header-color);
   font-weight: bold;
   font-size: 14px;
}

.few-shot-right-con .header span:first-child{
   margin-left: 20px;
}


.few-shot-right-con .k-animation-container{
   width: 100% !important;
}`, "",{"version":3,"sources":["webpack://./src/view/shot-examples/index.css"],"names":[],"mappings":"AAAA;GACG,WAAW;AACd;;;;CAIC;EACC,aAAa;AACf;;AAEA;GACG,cAAc;GACd,UAAU;GACV,SAAS;GACT,aAAa;GACb,mBAAmB;GACnB,UAAU;GACV,yCAAyC;GACzC,iBAAiB;GACjB,eAAe;AAClB;;AAEA;GACG,iBAAiB;AACpB;;;AAGA;GACG,sBAAsB;AACzB","sourcesContent":[".few-shot-right-con , .few-shot-left-con {\n   width: 100%;\n} \n \n \n \n .few-shot-left-con tr[aria-rowindex=\"2\"] {\n  display: none;\n}\n\n.few-shot-right-con .header{\n   height: 38.5px;\n   padding: 0;\n   margin: 0;\n   display: flex;\n   align-items: center;\n   gap: 300px;\n   background-color:var(--grid-header-color);\n   font-weight: bold;\n   font-size: 14px;\n}\n\n.few-shot-right-con .header span:first-child{\n   margin-left: 20px;\n}\n\n\n.few-shot-right-con .k-animation-container{\n   width: 100% !important;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
